import OverlayWithStyles from './ImageOverlay.styled'

export default OverlayWithStyles
